<template>
  <v-container fluid class="pt">
    <v-layout row wrap>
      <v-card class="elevation-0 shadow-md white mt-2 flex xs12">
        <v-card-text class="pt-4">
          <v-layout row wrap>
            <v-flex xs12 md4 class="di-flex align-center">
              <template v-if="can.add && !kyc">
                <v-btn
                  color="primary"
                  to="corporates/new"
                  v-if="$vuetify.breakpoint.mdAndUp"
                >
                  <v-icon class="mx-2">add_circle</v-icon>
                  <span class="mt-1">
                    {{ $t("new_customer") }}
                  </span>
                </v-btn>
                <!-- @click="showDialog" -->

                <v-btn
                  icon
                  flat
                  v-else
                  class="mx-0"
                  color="primary"
                  @click="showDialog"
                >
                  <v-icon>add_circle</v-icon>
                </v-btn>
              </template>
              <!-- <div v-if="kyc" class="red di-flex"> -->
              <strong v-if="kyc" class="body-2 px-3 py-2 lable-out grey6">{{
                title
              }}</strong>
              <!-- </div> -->
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 md7 class="di-flex justify-end align-center">
              <v-text-field
                outline
                singleLine
                hide-details
                v-model="search"
                class="rounded"
                style="max-width: 400px"
                :placeholder="$t('search')"
                prepend-inner-icon="search"
              />
              <v-btn
                flat
                icon
                class="mx-0"
                color="grey darken-2"
                @click="printTable(false)"
              >
                <v-icon>print</v-icon>
              </v-btn>
              <v-btn
                flat
                icon
                class="mx-0"
                color="grey darken-2"
                @click="printTable(true)"
              >
                <v-icon>file_download</v-icon>
              </v-btn>
              <v-btn
                flat
                icon
                class="mx-0"
                @click="getData"
                :loading="loading"
                color="grey darken-2"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="kyc" class="pa-2 my-2 shadow-md">
            <v-checkbox
              singleLine
              hideDetails
              color="primary"
              @change="getData"
              v-model="trashed"
              class="flex xs12 md4"
              style="max-width: 200px"
              :label="$t('deactivated')"
            />
            <v-checkbox
              singleLine
              hideDetails
              v-model="pep"
              color="primary"
              @change="getData"
              :label="$t('pep')"
              class="flex xs12 md4"
              style="max-width: 200px"
            />

            <v-checkbox
              singleLine
              hideDetails
              color="primary"
              @change="getData"
              class="flex xs12 md4"
              style="max-width: 200px"
              v-model="sanction_screening"
              :label="$t('sanction_screening')"
            />
          </v-layout>
          <v-data-table
            ref="tbl"
            item-key="id"
            :items="items"
            class="flex xs12"
            :loading="loading"
            :headers="headers"
            v-model="selected"
            :total-items="meta.total"
            :pagination.sync="pagination"
            :rows-per-page-items="per_page"
          >
            <template slot="items" slot-scope="{ item, index }">
              <tr>
                <td :class="{ red: item.deleted_at }">{{ index + 1 }}</td>
                <td>{{ item.branch && item.branch.code }}</td>
                <td>{{ item.customer_id }}</td>
                <td>
                  <router-link :to="`corporates/${item.customer_id}`">
                    {{ item.full_name }}
                  </router-link>
                </td>
                <td>{{ item.pretty_company_phones }}</td>
                <td>{{ item.business_address }}</td>
                <td>{{ item.reg_date }}</td>
                <template v-if="kyc">
                  <td>{{ item.kyc_updated_date }}</td>
                  <td
                    :class="{
                      'red lighten-3 red--text font-weight-bold': isExpired(
                        item.next_kyc_date
                      ),
                    }"
                  >
                    {{ item.next_kyc_date }}
                  </td>
                  <td>{{ item.license_issue_date }}</td>
                  <td
                    :class="{
                      'red lighten-3 red--text font-weight-bold': isExpired(
                        item.license_expire_date
                      ),
                    }"
                  >
                    {{ item.license_expire_date }}
                  </td>
                  <td>{{ item.risk_profile }}</td>
                </template>
                <td v-if="trashed">{{ item.deleted_at }}</td>
                <td v-if="can.any">
                  <v-btn
                    flat
                    icon
                    small
                    class="ma-0"
                    v-if="can.view"
                    color="grey darken-1"
                    :to="`corporates/${item.customer_id}`"
                  >
                    <v-icon>launch</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    flat
                    class="ma-0"
                    v-if="can.edit && !kyc"
                    color="grey darken-1"
                    :to="`corporates/edit/${item.customer_id}`"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    flat
                    small
                    class="ma-0"
                    v-if="can.delete && !kyc"
                    color="grey darken-1"
                    @click="deleteItem(item)"
                  >
                    <v-icon>delete_outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import debounce from "@/plugins/vDebounce";
import { customersMixin } from "@/mixins/index.js";

export default {
  name: "corporates",
  mixins: [customersMixin],
  data() {
    return {
      type: "corporate",
      items: [],
      search: "",
      selected: [],
      dialog: false,
      pep: false,
      trashed: false,
      sanction_screening: false,
      loading: false,
      meta: {
        total: 0,
        perPage: 0,
        current_page: 0,
      },
      customer: {},
      totalRows: 0,
      loading: true,
      editedIndex: -1,
      pagination: { page: 1, rowsPerPage: 50 },
    };
  },

  computed: {
    can() {
      return {
        add: this.userCan(`add_corporates`),
        view: this.userCan(`view_corporates`),
        edit: this.userCan(`edit_corporates`),
        delete: this.userCan(`delete_corporates`),
        any:
          this.userCan(`edit_corporates`) ||
          this.userCan(`view_corporates`) ||
          this.userCan(`delete_corporates`),
      };
    },
    currencies() {
      return this.initialData.currencies;
    },

    report() {
      let report = this.$store.state.route.query.report;
      let kyc = this.$store.state.route.query.kyc;
      return !!report || !!kyc;
    },

    kyc() {
      let kyc = this.$store.state.route.query.kyc;
      return !!kyc;
    },
    title() {
      if (this.kyc) return "Corporates Report";
      else return "Corporates List";
    },

    headers: (vm) => {
      let items = [
        {
          value: "index",
          width: "100px",
          sortable: false,
          text: vm.$t("number"),
        },
        {
          width: "80px",
          sortable: false,
          value: "branch.code",
          text: vm.$t("branch"),
        },
        {
          width: "80px",
          sortable: false,
          value: "customer_id",
          text: vm.$t("reg_no"),
        },
        {
          sortable: false,
          value: "full_name",
          text: vm.$t("customer"),
        },
        {
          sortable: false,
          text: vm.$t("phones"),
          value: "pretty_company_phones",
        },
        {
          sortable: false,
          value: "business_address",
          text: vm.$t("business_address"),
        },
        {
          sortable: false,
          value: "reg_date",
          text: vm.$t("reg_date"),
        },
      ];

      if (vm.kyc) {
        items.push(
          {
            sortable: false,
            value: "kyc_updated_date",
            text: vm.$t("kyc_updated_date"),
          },
          {
            sortable: false,
            value: "next_kyc_date",
            text: vm.$t("next_kyc_date"),
          },
          {
            sortable: false,
            value: "license_issue_date",
            text: vm.$t("license_issue_date"),
          },
          {
            sortable: false,
            value: "license_expire_date",
            text: vm.$t("license_expire_date"),
          },
          {
            sortable: false,
            value: "risk_profile",
            text: vm.$t("risk_profile"),
          }
        );
      }
      if (vm.trashed) {
        items.push({
          sortable: false,
          hidePrint: true,
          value: "deleted_at",
          text: vm.$t("deleted_at"),
        });
      }
      items.push({
        sortable: false,
        value: "actions",
        text: vm.$t("actions"),
      });
      return items;
    },
    // total() {
    //   let barrow = { name: "مجموع طلب" };
    //   let loan = { name: "مجموع قروض" };

    //   this.items.forEach(item => {
    //     this.currencies.forEach(currency => {
    //       if (
    //         item.mapped_accounts[currency.id] &&
    //         item.mapped_accounts[currency.id].balance < 0
    //       )
    //         loan[currency.id] =
    //           (loan[currency.id] || 0) +
    //           Number(item.mapped_accounts[currency.id].balance);
    //       else if (
    //         item.mapped_accounts[currency.id] &&
    //         item.mapped_accounts[currency.id].balance > 0
    //       )
    //         barrow[currency.id] =
    //           (barrow[currency.id] || 0) +
    //           Number(item.mapped_accounts[currency.id].balance);
    //     });
    //   });
    //   return { loan, barrow };
    // }
  },
  methods: {
    isExpired(date) {
      return !date || new Date(date) <= new Date();
    },
    getData() {
      this.loading = true;
      let { search, trashed, pep, sanction_screening } = this;
      const { page, rowsPerPage } = this.pagination;
      let params = {
        pep,
        page,
        search,
        trashed,
        type: "corporate",
        sanction_screening,
        per_page: rowsPerPage,
      };
      this.axios
        .get(`corporates`, { params })
        .then((resp) => {
          this.items = resp.data.data;
          this.meta = resp.data.meta;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    deleteItem(item) {
      let vm = this;
      this.$alert("customers/" + item.customer_id).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1); // remove items
      });
    },

    reset() {
      this.dialog = false;
      this.customer = {
        name: "",
        phones: "",
        address: "",
        type: "customer",
        last_form_number: 100,
      };
      this.editedIndex = -1;
    },

    showDialog() {
      this.reset();
      this.dialog = true;
    },

    save(customer) {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], customer);
      } else {
        this.items.push(customer);
      }
      this.reset();
    },

    printTable(excel) {
      let headers = this.headers.slice(1, -1);
      if (excel)
        headers.push(
          {
            sortable: false,
            value: "nature_of_business",
            text: this.$t("nature_of_business"),
          },
          {
            sortable: false,
            value: "tin_number",
            text: this.$t("tin_number"),
          },
          {
            sortable: false,
            value: "incorporation_date",
            text: this.$t("incorporation_date"),
          },
          {
            sortable: false,
            value: "reg_name",
            text: this.$t("reg_name"),
          },
          {
            sortable: false,
            value: "reg_address",
            text: this.$t("reg_address"),
          },
          {
            sortable: false,
            value: "license_no",
            text: this.$t("license_no"),
          },
          {
            sortable: false,
            value: "license_issue_date",
            text: this.$t("license_issue_date"),
          },
          {
            sortable: false,
            value: "license_expire_date",
            text: this.$t("license_expire_date"),
          },
          {
            sortable: false,
            value: "monthly_income",
            text: this.$t("monthly_income"),
          },
          {
            sortable: false,
            value: "monthly_turnover",
            text: this.$t("monthly_turnover"),
          },
          {
            sortable: false,
            value: "company_email",
            text: this.$t("company_email"),
          }
        );

      let data = {
        headers,
        landscape: true,
        title: this.title,
        items: this.$refs.tbl.filteredItems,
      };

      if (excel) return this.xl_tables(data, "corporates", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },
  created() {
    this.reset();
  },
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    search: debounce(function (newVal) {
      this.getData(newVal);
    }, 1000),
  },
};
</script>